export enum Hotkeys {
    HOTKEY_NAME = "show-hide-porofessor",
    UNASSIGEND = "Unassigned"
}

//------------------------------------------------------------------------------
export class OWHotkeys {

  //----------------------------------------------------------------------------
  private constructor() {
  }

  private static _get(hotkeyId: string,
                      callback: (hotkey: string) => void): void {
    overwolf.settings.getHotKey(hotkeyId, function (result: any) {
      if (!result || result.status === "error" || !result.hotkey) {
        callback(Hotkeys.UNASSIGEND);
        // setTimeout(() => {
        //   OWHotkeys._get(hotkeyId, callback);
        // }, 2000);
      } else {
        callback(result.hotkey);
      }
    });
  }

  //----------------------------------------------------------------------------
  private static _set(hotkeyId: string,
                      action: () => void): void {
    overwolf.settings.registerHotKey(hotkeyId, function (result) {
      if (result.success) {
        action();
      } else {
        console.error(`[HOTKEYS SERVICE] failed to register hotkey ${hotkeyId}`);
      }
    });
  }

  //----------------------------------------------------------------------------
  public static getToggleHotkey(): Promise<string> {
    return new Promise((resolve, reject) => {
      OWHotkeys._get(Hotkeys.HOTKEY_NAME, resolve);
    });
  }

  //----------------------------------------------------------------------------
  public static setToggleHotkey(action: () => void): void {
    OWHotkeys._set(Hotkeys.HOTKEY_NAME, action);
  }

  //----------------------------------------------------------------------------
  public static addHotkeyChangeListener(listener: (info: any) => void): void {
    overwolf.settings.OnHotKeyChanged.addListener(listener);
  }

  //----------------------------------------------------------------------------
  public static beautifyHotkeyString(originalHotkey: string) {
    let hotkey = originalHotkey.split("+").join(" + ");
    return hotkey;
  }
}
